import React from "react";
import { StoreLabelType, StoreLabelUiType } from "../../../constants";
import { styled, Chip } from "@material-ui/core";
import sortBy from "lodash/sortBy";
import { analyticsTrackEvent } from "../../../../../services/analytics";

type Props = {
  labels: StoreLabelUiType[];
  onLabelClick: (label: StoreLabelType) => void;
};

const Wrapper = styled("div")(({ theme }) => ({
  display: "flex",
  justifyItems: "center",
  alignItems: "center",
  [theme.breakpoints.down("sm")]: {
    flexWrap: "wrap"
  }
}));

const CustomChip = styled(Chip)(({ theme }) => ({
  minWidth: theme.spacing(15),
  "&.MuiChip-root": {
    backgroundColor: "#FFFFFF",
    borderRadius: "8px"
  },
  "&.MuiChip-outlined": {
    backgroundColor: "#FFFFFF"
  },
  "&.MuiChip-deletable": {
    borderRadius: "8px",
    backgroundColor: theme.palette.primary.main,
    borderStyle: "solid",
    borderColor: "#D39D07",
    borderWidth: "0.81px"
  },
  "& > .MuiChip-label": {
    fontFamily: "Roobert",
    fontSize: "1.2rem",
    lineHeight: "1.6rem",
    letterSpacing: "1.5px",
    fontWeight: 600
  },
  "&:not(:last-child)": {
    marginRight: theme.spacing(2)
  },
  [theme.breakpoints.down("sm")]: {
    width: `calc(50% - ${theme.spacing(3)}px)`,
    minWidth: "none",
    marginBottom: theme.spacing(2),
    "&:not(:last-child)": {
      marginRight: theme.spacing(3)
    }
  }
}));

const LabelsFilter = React.memo(({ labels, onLabelClick }: Props) => {
  return (
    <Wrapper>
      {sortBy(labels, "position").map(label => {
        if (!label.isSelected && label.hidden) {
          return null;
        }
        return (
          <CustomChip
            key={label.originalId}
            onClick={() => {
              onLabelClick(label);
            }}
            onDelete={label.isSelected ? () => onLabelClick(label) : undefined}
            label={label.text.toUpperCase()}
            variant={label.isSelected ? "default" : "outlined"}
          />
        );
      })}
    </Wrapper>
  );
});

export default LabelsFilter;
